var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJm = function SvgJm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M19.306 2.48A11.946 11.946 0 0 0 12 0C9.25 0 6.718.925 4.694 2.48L12 9.787l7.306-7.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.48 4.694A11.947 11.947 0 0 0 0 11.999c0 2.75.925 5.283 2.48 7.306L9.787 12 2.481 4.694Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M4.694 21.519A11.947 11.947 0 0 0 12 23.999c2.75 0 5.282-.925 7.306-2.48L12 14.213l-7.306 7.306Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.52 19.305A11.946 11.946 0 0 0 24 12c0-2.75-.925-5.282-2.48-7.305l-7.306 7.305 7.306 7.306Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgJm;